module.exports = __webpack_public_path__ + "images/howtouse/flow01_cdd811eb6f913603c9bf59f9850d4d30.png";